import React from "react";
import { FinancialTableReference } from "models/AiResearch";
import styles from "./style.scss";

const isNumericCell = (value: string | number) => typeof value === "number";

interface Props {
  reference: FinancialTableReference;
}

export const FinancialTable: React.FC<Props> = ({ reference }) => {
  return (
    <div className={styles.container}>
      <span className={styles.citationNumber}>{reference.citationNumber}</span>
      <h2 className={styles.title}>{reference.data.content.name}</h2>
      <p className={styles.description}>{reference.data.content.description}</p>
      <div className={styles.tableContainer}>
        <table className={styles.vsTable}>
          <thead>
            <tr>
              {reference.data.content.header.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {reference.data.content.values.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className={
                      isNumericCell(cell) ? styles.numericCell : undefined
                    }
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
